//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "TeamsTab",
  props: ["value"],
  components: {},
  mounted: function () {
    BackendServices.getSalesforceHierarchyLevelElements().then((result) => {
      this.hierarchy = result.data.filter((item) => item.child_ids.length);
      this.hierarchy.forEach((item) => {
        this.findEmployeesByNameAndRole(null, item.id);
      });
    });
    this.findEmployeesByName(null);
    this.validateData();
  },
  data: function () {
    return {
      moment,
      currentRole: null,
      hierarchy: [],
      areaList: [],
      sellerList: [],
      routeList: [],
      managersList: {},
      newRegistry: true,
      validForm: false,
    };
  },
  methods: {
    required,
    noValidation,
    deleteRecord: async function () {
      let response = await BackendServices.deleteSalesforceTeam(this.value);
      this.$emit("change-tab", response.status);
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    findEmployeesByName: function (search) {
      return BackendServices.getSalesforceHierarchyLevelElements().then(
        (hierarchyResult) => {
          return BackendServices.getSalesforceEmployees(
            { page: 1, rowsPerPage: 1000 },
            search && search.length ? search : null
          ).then((result) => {
            this.sellerList = result.data.filter(
              (item) =>
                item.role_id ===
                hierarchyResult.data.filter((item) => !item.child_ids.length)[0]
                  .id
            );
          });
        }
      );
    },
    findEmployeesByNameAndRole: async function (search, role) {
      let result = await BackendServices.getSalesforceEmployees(
        { page: 1, rowsPerPage: 1000 },
        search && search.length ? search : null
      );
      this.$set(
        this.managersList,
        role,
        result.data.filter((item) => item.role_id === role)
      );
    },
    filterEmployeesByName: function (name, update) {
      update(async () => {
        await this.findEmployeesByName(null);
        this.sellerList = this.sellerList.filter(
          (seller) => seller.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
        );
      });
    },
    filterEmployeesByNameAndRole: function (event, update) {
      update(() => {
        Object.keys(this.managersList).forEach(async (item) => {
          await this.findEmployeesByNameAndRole(null, parseInt(item, 10));
          this.$set(
            this.managersList,
            item,
            this.managersList[item].filter(
              (seller) =>
                seller.name.toLowerCase().indexOf(event.toLowerCase()) >= 0
            )
          );
        });
      });
    },
    addToModel(event, role_id) {
      this.value.manager_ids.push(event.value);
      let item = this.managersList[role_id].filter(
        (item) => item.id === event.value
      )[0];
      this.value.managers.push(item);
      this.updateData();
    },
    removeFromModel(event) {
      this.value.manager_ids.splice(
        this.value.manager_ids.indexOf(event.value),
        1
      );
      let auxList = this.value.managers.map((value) => value.id);
      this.value.managers.splice(auxList.indexOf(event.value), 1);
      this.updateData();
    },
    updateData() {
      this.$emit("value", this.value);
    },
  },
  computed: {},
};
